module.exports = __webpack_public_path__ + "img/discount-percent-line-default.5c518514.svg";